import {
  ChangeDetectionStrategy,
  Component,
  Injectable,
  inject,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ConfirmCloseReason } from '../../shared.types';

interface ConfirmOptions {
  title: string;
  message: string;
  modalClass?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: 'confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule],
})
export class ConfirmDialogComponent {
  private modalRef = inject(NgbActiveModal);

  public options: ConfirmOptions;

  protected closing = false;

  protected yes() {
    this.closing = true;
    this.modalRef.close({
      closeReason: ConfirmCloseReason.Yes,
    });
  }

  protected no() {
    this.closing = true;
    this.modalRef.close({
      closeReason: ConfirmCloseReason.No,
    });
  }
}

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private ngbModal = inject(NgbModal);

  public confirm(
    options: ConfirmOptions
  ): Observable<{ closeReason: ConfirmCloseReason }> {
    const modalRef = this.ngbModal.open(ConfirmDialogComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      modalDialogClass: options.modalClass || 'modal-size-sm',
    });
    modalRef.componentInstance.options = options;

    return modalRef.closed;
  }
}
